const isMobile = () => {
  var isMobile =
    /iPhone|iPad|iPod|Android|BlackBerry|Opera Mini|IEMobile|WPDesktop/i.test(
      navigator.userAgent
    );
  if (isMobile) return true;
  else return false;
};

const downloadPDFFromStringBase64 = function (data, name) {
  const linkSource = `data:application/pdf;base64,${data}`;
  const downloadLink = document.createElement("a");
  const fileName = name;
  downloadLink.href = linkSource;
  downloadLink.download = fileName;
  downloadLink.click();
};

const orderArray = function (array, attribute) {
  array.sort(function (a, b) {
    if (a[attribute] < b[attribute]) return -1;
    if (a[attribute] > b[attribute]) return 1;
    return 0;
  });
};

//Reinicia los elementos del formulario, sus valores, y
//reinicia sus valores con hooks opcionales.
const clearElementValues = (elementsName, setElements) => {
  let newElements = Object.assign({}, elementsName);
  Object.keys(newElements).map((key) => {
    let element = newElements[key];
    if (element.elementType === "date") {
      // console.log("element:", element);
      const newDate = new Date();
      element.value = newDate;
      element.defaultValue = newDate;
      if (element.useStateHook) {
        element.useStateHook("");
      }
    } else {
      if (!element.hasOwnProperty("defaultValue")) {
        element.value = "";
        if (element.useStateHook) {
          element.useStateHook("");
        }
      }
    }

    if (!element.hasOwnProperty("defaultValue")) {
      if (element.key && element.keys) {
        if (element.key === element.keys[0]) {
          element.key = element.keys[1];
        } else {
          element.key = element.keys[0];
        }
      }
    }

    if (element.isError !== undefined) {
      element.isError = false;
    }
    if (element.enableOnExit != null && element.enableOnExit === true) {
      element.disabled = false;
    }
    if (element.cleanListOnExit != null && element.cleanListOnExit === true) {
      element.list = [];
    }
  });
  setElements(newElements);
};

//Reiniciar solo un element.
const clearElementValue = (elementsName, elementName, setElements) => {
  let newElements = Object.assign({}, elementsName);
  let element = newElements[elementName];
  if (element.elementType === "date") {
    // console.log("element:", element);
    const newDate = new Date();
    element.value = newDate;
    element.defaultValue = newDate;
    if (element.useStateHook) {
      element.useStateHook("");
    }
  } else {
    element.value = "";
    if (element.useStateHook) {
      element.useStateHook("");
    }
  }

  if (element.key && element.keys) {
    if (element.key === element.keys[0]) {
      element.key = element.keys[1];
    } else {
      element.key = element.keys[0];
    }
  }
  if (element.isError !== undefined) {
    element.isError = false;
  }
  if (element.enableOnExit != null && element.enableOnExit === true) {
    element.disabled = false;
  }
  if (element.cleanListOnExit != null && element.cleanListOnExit === true) {
    element.list = [];
  }

  // }
  setElements(newElements);
};

// Reemplaza los keys en el element para triggerear un re-render.
const switchKeysInElements = (elementsName) => {
  let newElements = Object.assign({}, elementsName);
  Object.keys(newElements).map((key) => {
    let element = newElements[key];
    if (element.key && element.keys) {
      if (element.key === element.keys[0]) {
        element.key = element.keys[1];
      } else {
        element.key = element.keys[0];
      }
    }
  });
  // setElements(newElements);
  return newElements;
};

//Itera un arreglo de objetos como los "elements" que mandamos al FormTwoColumns para
//evaluar si un element requerido está vacío o "default", para triggerear su helper text que permite ver
//un texto en color rojo que indica el mensaje de error.
const checkIsEmptyWhenRequiredElement = (elementsName, setElements) => {
	let isAllGood = true;
	let newElements = Object.assign({}, elementsName);
	Object.keys(newElements).map((key) => {
		let element = newElements[key];
		if (element.elementType === "checkboxList") {
			let checkedBoxes = 0;
			element.list.forEach((option) => {
				if (option.checked) {
					checkedBoxes++;
				}
			});
			if (checkedBoxes < element.requiredChecks) {
				element.isError = true;
			} else {
				element.isError = false;
			}
		} else if (element.elementType === "date") {
			if (
        (element.value === null && element.validators[0] === "required") ||
				(element.value === element.defaultValue && element.validators[0] === "required" ) ||
				(element.value === '' && element.validators[0] === "required" ) ||
				(element.value === null && element.validators[0] === "required" ) 
			) {
				element.isError = true;
				isAllGood = false;
			}
		} else if (element.elementType === "autocompleteV2") {
			if (
				(element.value === null && element.validators[0] === "required" ) ||
				(element.value === '' && element.validators[0] === "required" ) ||
				(element.value === undefined && element.validators[0] === "required" ) 
			) {
				element.isError = true;
				isAllGood = false;
			}
		} else {
			if (element.value === "" && element.validators[0] === "required") {
				element.isError = true;
				isAllGood = false;
			}
			if (element.requiredLength) {
				if (element.value.length != element.requiredLength) {
					element.isError = true;
					isAllGood = false;
				}
			}
		}
	});
	setElements(newElements);
	return isAllGood;
};

//le damos formato a las fechas yy-mm-dd
const splitDate = function (date) {
  if (date !== undefined) {
    if (date !== null) {
      var arr1 = date.split("-");
      if (arr1.length === 1) return date;
      var arr2 = arr1[2].split("T");
      var fecha = new Date(date);
      // var hora = fecha.getHours();
      // var minutos = fecha.getMinutes();
      // var segundos = fecha.getSeconds();
      // var finalDate = arr1[0] + "-" + arr1[1] + "-" + arr2[0]+' '+hora+':'+minutos+':'+segundos;
      var finalDate = arr2[0] + "/" + arr1[1] + "/" + arr1[0];
      // console.log(finalDate)
      return finalDate;
    }
  }
};
//le damos formato a las fechas yy-mm-dd
const splitDateCustom = function (fecha) {
  let date = new Date(fecha);
  if (date !== undefined) {
    if (date !== null) {
      var arr1 = date.split("-");
      var arr2 = arr1[2].split("T");
      var finalDate = arr1[0] + "-" + arr1[1] + "-" + arr2[0]+'T00:00:00.000Z';
      return finalDate;
    }
  }
};
//le damos formato a las fechas yy-mm-dd
const splitDateCustomFormat = function (date) {
  if (date !== undefined) {
    if (date !== null) {
      var arr1 = date.split("-");
      var arr2 = arr1[2].split("T");
      var finalDate = arr1[0] + "-" + arr1[1] + "-" + arr2[0]+'T06:00:00.000Z';
      return finalDate;
    }
  }
};
// Aplicamos la diferencia en horario

const aplicarDiferenciaHoraria = function (hora, diferenciaEnHoras) {
  // console.log("hora: ", hora);
  let primerSplit = hora.split(":");
  // console.log("primerSplit:", primerSplit);
  let horaEnNumeros = Number(primerSplit[0]);
  // console.log("horaEnNumeros:", horaEnNumeros);
  let nuevaHoraEnNumeros = horaEnNumeros + Number(diferenciaEnHoras);
  // console.log("nuevaHoraEnNumeros:", nuevaHoraEnNumeros);
  let nuevaHoraEnString = nuevaHoraEnNumeros.toString();
  if (nuevaHoraEnNumeros < 10) {
    nuevaHoraEnString = "0" + nuevaHoraEnString;
  }
  nuevaHoraEnString =
    nuevaHoraEnString + ":" + primerSplit[1] + ":" + primerSplit[2];
  // console.log("nuevaHoraEnString:", nuevaHoraEnString);
  return nuevaHoraEnString;
};

const dateFormatGeneral = (date, dataToReturn = "") => {
  if (date) {
    if (typeof date == "string") {
      return splitDate(date);
    }

    const start = new Date(`${date?.toDateString()}`);
    const options = { year: "numeric", month: "numeric", day: "2-digit" };
    return start.toLocaleDateString("es-ES", options);
  }
  return dataToReturn;
};

/** FUNCTION TO VALIDATE FILE TYPE
 * description fucntion to validate file type
 * params
 *   currentFile = currentFile is the file currently selected,
 *   element = is the input file of the form
 */
const validateFileType = (currentFile, accept) => {
  const fileAccept = accept ? accept.split(", ") : [];
  const fileType = currentFile.name.split(".").reverse()[0];
  return fileAccept.includes(`.${fileType}`);
};

/** FUNCTION TO VALIDATE FILE SIZE
 * description fucntion to validate file size
 * params
 *   currentFile = currentFile is the file currently selected,
 *   sizeAccepted = is the size accepted of the file in MB
 */
const validateFileSize = (currentFile, sizeAccepted) => {
  const oneMegaInBytes = 1048576;
  const splitSize = sizeAccepted.split(" ");
  const sizeFile =
    splitSize.length === 1
      ? oneMegaInBytes
      : Number(splitSize[0]) * oneMegaInBytes;
  return currentFile.size > sizeFile;
};
const splitBase64 = function (base64) {
  if (base64 !== undefined) {
    if (base64 !== null) {
        var getBase64 = base64.split("base64,");
        if(getBase64.length > 0){
            return getBase64[1];
        }
    }
  }
}; 
export const functions = {
  isMobile: isMobile,
  downloadPDFFromStringBase64: downloadPDFFromStringBase64,
  orderArray: orderArray,
  splitDate: splitDate,
  switchKeysInElements: switchKeysInElements,
  clearElementValues: clearElementValues,
  clearElementValue: clearElementValue,
  checkIsEmptyWhenRequiredElement: checkIsEmptyWhenRequiredElement,
  aplicarDiferenciaHoraria: aplicarDiferenciaHoraria,
  dateFormatGeneral,
  validateFileSize,
  validateFileType,
  splitDateCustom,
  splitDateCustomFormat,
  splitBase64,
};
